import React from 'react';
import { Modal, Button } from '@tvg/fuse-design';
import styled from 'styled-components';
import { CustomPromotionVoucher } from '../../../types/Product';

const DialogDescription = styled.div`
  padding-bottom: var(--spacing-space16);
  margin-top: -8px;

  .dialog-description-style {
    p {
      color: var(--color-font-paragraph);
      font-weight: var(--font-weight-paragraph);
      font-size: var(--font-size-m1);
      line-height: var(--font-line-height-m1);
      padding-bottom: var(--spacing-space8);
    }
    h1 {
      color: var(--color-font-heading);
      font-weight: var(--font-weight-heading);
      font-size: var(--font-size-1);
      line-height: var(--font-line-height-1);
      padding-bottom: var(--spacing-space8);
    }
    h2 {
      color: var(--color-font-heading);
      font-weight: var(--font-weight-heading);
      font-size: var(--font-size-1);
      line-height: var(--font-line-height-1);
      padding-bottom: var(--spacing-space8);
      padding-top: var(--spacing-space16);
    }
    ul {
      list-style: inside;
      padding-left: var(--spacing-space8);
    }
    li {
      color: var(--color-font-paragraph);
      font-weight: var(--font-weight-paragraph);
      font-size: var(--font-size-m1);
      line-height: var(--font-line-height-m1);
    }
    ol {
      list-style: decimal !important;
      padding-left: var(--spacing-space8);
    }
  }
`;
const ButtonContainer = styled.div`
  padding-top: var(--spacing-space16);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  margin: auto;

  @media (max-width: 430px) {
    max-width: 100%;
  }

  @media (min-width: 431px) {
    max-width: var(--spacing-space96); /* Example of making the button smaller */
    /* Add other styles to make the button smaller */
  }
`;

function CustomVoucherDialog({
  promotionVoucher: { dialogDescription, dialogTitle },
  dialogOpen,
  closeDialog,
  handleClose,
}: {
  promotionVoucher: CustomPromotionVoucher;
  dialogOpen: boolean;
  closeDialog: () => void;
  handleClose: () => void;
}) {
  return (
    <Modal
      name="custom_promotion_voucher_dialog"
      open={dialogOpen}
      onClose={closeDialog}
      title={dialogTitle}
      dataTestId="custom_promotion_voucher_dialog"
      srLabelCloseButton="close promotion voucher"
      zIndex="20"
    >
      <DialogDescription
        data-testid="custom_voucher_dialog_description"
        dangerouslySetInnerHTML={{
          __html: `${dialogDescription}`,
        }}
      />

      <ButtonContainer data-testid="voucher_dialog_button_container">
        <Button variant="tertiary" onClick={handleClose} dataTestId="handle_close_button" fullWidth size="medium">
          Close
        </Button>
      </ButtonContainer>
    </Modal>
  );
}

export default CustomVoucherDialog;
